import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';
import { ResetPassword, ResetPasswordValidation, UserLogin } from '../../Data';

const ResetPassAR = (props) => {
    const [email, setEmail] = useState("")
    const navigate = useNavigate();
    const [confirmPassword, setConfirmPassword] = useState('');
    const [password, setPassword] = useState("");
    const [old, setOld] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!ResetPasswordValidation(password, confirmPassword)) return;

        try {
            // 1️⃣ Reset password
            await ResetPassword(email, old, password);

            // 2️⃣ Login again (same as Login page)
            const Result = await UserLogin(email, password);

            // 3️⃣ SAME cookies as login
            // props.setSubscribe(Result.IsSubscribed);

            Cookies.set('User', email, { expires: 5 });
            Cookies.set('WishList', Result.WishlistId, { expires: 5 });
            Cookies.set('Cart', Result.CartId, { expires: 5 });
            Cookies.set('Subscribe', Result.IsSubscribed, { expires: 5 });
            Cookies.set('Number', Result.CustomerId, { expires: 5 });
            Cookies.set('CustomerToken', Result.Token, { expires: 5 });

            toast.success("Password reset successful");

            // 4️⃣ SAME redirect behavior
            window.location.href = "/AR/Account";

        } catch (error) {
            const message = error?.message?.replaceAll('"', "");

            if (message === "Please Confirm Your Email") {
                navigate("/Email-Confirmation");
            } else if (message === "Please Reset Your Password") {
                navigate("/AR/Reset-Password");
            }

            toast.error(message || "Error");
        }
    };

    return (
        <>
            <div className="breadcrumb-area mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="breadcrumb-container d-flex flex-row-reverse">
                                <div className="breadcrumbArabic">
                                    <ul>
                                        <li className="active">إعادة تعيين كلمة المرور</li>
                                        <li>
                                            <a style={{ direction: 'rtl' }} href="/">
                                                <i className="fa fa-home"></i> المنزل
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center mt-2">
                <div className="col-12 col-md-8">
                    <div className="authenticationCard">
                        <div className="row topBar">
                            <div className="col-12 text-center">
                                {/* <button className='active'> إعادة تعيين كلمة المرور</button> */}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>البريد الالكترةني</label></div>
                            <div className="col-12 col-md-10">
                                <input type="email" className="form-control" placeholder="البريد الالكترةني" required onChange={(e) => setEmail(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>كلمة المرور القديمة:</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" placeholder="كلمة المرور القديمة" required onChange={(e) => setOld(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>كلمة المرور اجديدة:</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" placeholder="Type Here" required onChange={(e) => setPassword(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12 col-md-2"><label>تأكيد كلمة المرور</label></div>
                            <div className="col-12 col-md-10">
                                <input type="password" className="form-control" placeholder="تأكيد كلمة المرور" required onChange={(e) => setConfirmPassword(e.target.value)}></input>
                            </div>
                        </div>
                        <div className="row mb-3 submit">
                            <div className="col-12 text-center">
                                <button className="Resend-button mt-0 RemUnderline" onClick={(e) => handleSubmit(e)}>اعادة تعيين</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ResetPassAR